<p-tabView>
    <p-tabPanel header="{{'vbeiInclude' | translate}}" [selected]="true">
        <div class="header">{{advanceSearchLabels.alsoSearchOnLabel}}</div>
        <ul class="search-on-list">
            <li>
                <p-checkbox [(ngModel)]="includeProperties.comments" name="searchOn" value="{{'vbeiTestInstructions' | translate}}"
                    label="{{advanceSearchLabels.testInstructionsLabel}}" binary="true"
                    (onChange)="resetCombineSearch('comments')"></p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.description" name="searchOn" value="{{'vbeiDescription' | translate}}"
                    label="{{advanceSearchLabels.descriptionLabel}}" binary="true"
                    (onChange)="resetCombineSearch('description')">
                </p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.applicableOn" name="searchOn" value="{{'vbeiAppliedOn' | translate}}"
                    label="{{advanceSearchLabels.appliedOnLabel}}" binary="true"
                    (onChange)="resetCombineSearch('applicableOn')"></p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.objective" name="searchOn" value="{{'vbeiObjective' | translate}}"
                    label="{{advanceSearchLabels.objectiveLabel}}" binary="true"
                    (onChange)="resetCombineSearch('objective')"></p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.method" name="searchOn" value="{{'vbeiMethod' | translate}}"
                    label="{{advanceSearchLabels.methodLabel}}" binary="true" (onChange)="resetCombineSearch('method')">
                </p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.parameterCode" name="searchOn" value="{{'vbeiParameterCode' | translate}}"
                    label="{{advanceSearchLabels.parameterCodeLabel}}" binary="true"
                    (onChange)="resetCombineSearch('parameterCode')"></p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.parameterName" name="searchOn" value="{{'vbeiParameterName' | translate}}"
                    label="{{advanceSearchLabels.parameterNameLabel}}" binary="true"
                    (onChange)="resetCombineSearch('parameterName')"></p-checkbox>
            </li>
            <li>
                <p-checkbox [(ngModel)]="includeProperties.CASNumber" name="searchOn" value="{{'vbeiCASNumber' | translate}}"
                    label="{{advanceSearchLabels.CASNumberLabel}}" binary="true"
                    (onChange)="resetCombineSearch('CASNumber')"></p-checkbox>
            </li>
        </ul>
        <div class="more-options overlay-footer flex-body justify-content-between">
            <a class="anchor" (click)="refineButtonClicked()">{{advanceSearchLabels.refineSearchLabel}}</a>
            <a class="clickable" (click)="clearAllButtonClicked()">{{advanceSearchLabels.clearAllLabel}}</a>
        </div>
    </p-tabPanel>
    <p-tabPanel header="{{'vbeiCombine' | translate}}">
        <div class="header">{{advanceSearchLabels.combineSearchOnLabel}}</div>
        <div class="form-vertical search-on-form">
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.testInstructionsLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.comments" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('comments')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.descriptionLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.description" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('description')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.appliedOnLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.applicableOn" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('applicableOn')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.objectiveLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.objective" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('objective')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.methodLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.method" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('method')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.parameterCodeLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.parameterCode" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('parameterCode')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.parameterNameLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.parameterName" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('parameterName')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label-div">
                    <div class="form-label">{{advanceSearchLabels.CASNumberLabel}}</div>
                </div>
                <div class="form-input-div">
                    <textarea [(ngModel)]="combineProperties.CASNumber" maxlength="50" [rows]="1"
                        (blur)="updateIncludeProperty('CASNumber')" dopAutoResize pInputTextarea></textarea>
                </div>
            </div>
        </div>
        <div class="more-options overlay-footer flex-body justify-content-between">
            <a class="anchor" (click)="refineButtonClicked()">{{advanceSearchLabels.refineSearchLabel}}</a>
            <a class="clickable" (click)="clearAllButtonClicked()">{{advanceSearchLabels.clearAllLabel}}</a>
        </div>
    </p-tabPanel>
</p-tabView>